import React from 'react';

export function DeleteConfirmModal({ product, onConfirm, onCancel }) {
  if (!product) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onCancel}>
      <div className="bg-white p-6 max-w-sm w-full" onClick={e => e.stopPropagation()} data-testid="delete-confirm-modal">
        <p className="font-playfair text-lg text-[#0A0A0A] mb-1">Remove Product?</p>
        <p className="text-sm text-[#555555] font-work mb-1">{product.designer} — {product.name}</p>
        <p className="text-xs text-[#999999] font-work mb-6">This hides it from the store. Restore it any time by editing the product.</p>
        <div className="flex gap-3">
          <button onClick={onConfirm} data-testid="confirm-delete-btn"
            className="flex-1 bg-red-500 text-white py-3 text-xs uppercase tracking-wider font-work hover:bg-red-600 transition-colors">
            Remove
          </button>
          <button onClick={onCancel}
            className="flex-1 border border-[#E5E5E5] text-[#555555] py-3 text-xs uppercase tracking-wider font-work hover:border-[#D4AF37]">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export function BulkDeleteModal({ count, deleting, onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onCancel}>
      <div className="bg-white p-6 max-w-sm w-full" onClick={e => e.stopPropagation()} data-testid="bulk-delete-confirm-modal">
        <p className="font-playfair text-lg text-[#0A0A0A] mb-1">Remove {count} Product{count > 1 ? 's' : ''}?</p>
        <p className="text-xs text-[#999999] font-work mb-6">These products will be hidden from the store. You can restore them by editing each product.</p>
        <div className="flex gap-3">
          <button onClick={onConfirm} disabled={deleting} data-testid="confirm-bulk-delete-btn"
            className="flex-1 bg-red-500 text-white py-3 text-xs uppercase tracking-wider font-work hover:bg-red-600 transition-colors disabled:opacity-50">
            {deleting ? 'Removing...' : `Remove ${count}`}
          </button>
          <button onClick={onCancel}
            className="flex-1 border border-[#E5E5E5] text-[#555555] py-3 text-xs uppercase tracking-wider font-work hover:border-[#D4AF37]">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
